import { FC } from "react";

import { Tag } from "antd";

import { useAppSelector } from "@/hooks/redux";

const IsExaminationTag: FC = () => {
  const m15 = useAppSelector((state) => state.currentDataReducer.m15);

  return (
    <>
      {m15 ? (
        <Tag color="green">examination ON</Tag>
      ) : (
        <Tag color="gold">examination OFF</Tag>
      )}
    </>
  );
};

export default IsExaminationTag;
